import React from 'react';
import {
    Box,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    useBreakpointValue,
} from "@chakra-ui/react";
import SocialMedias from "../SocialMedias";
import {motion} from "framer-motion";

const MotionModalContent = motion(ModalContent);

const PopUpContact = ({overlay, isOpen, onClose}) => {
    const bottom = useBreakpointValue({base: "-50px", sm: "none"})
    return (
        <Modal
            isCentered
            isOpen={isOpen}
            onClose={onClose}
        >
            {overlay}
            <MotionModalContent
                position="fixed"
                exit={{translateY: "150%"}}
                right="0" left="0"
                bottom={bottom}
                maxW="420px" h="auto"
                mx="auto" marginTop="0"
                marginBottom="0"
                className="modal-content"
                borderTopRadius={{base: "20px", sm: "none"}}
                p="26px 23px" bg="#E0E0E0"
                rounded={{base: "0px 0px 26px 26px;", sm: "20px"}}
            >
                <Box onClick={onClose} display={{base: "block", sm: "none"}} w='92px' h='6px' bg='#CFCFCF'
                     rounded='11px' mx='auto'/>
                <ModalCloseButton size="15px" right="30px" top={{base: "50px", sm: "20px"}}/>
                <ModalBody py={16}>
                    <SocialMedias/>
                </ModalBody>
            </MotionModalContent>
        </Modal>
    );
};

export default PopUpContact;